import { render } from "./Block.vue?vue&type=template&id=bfc63e4a&scoped=true"
import script from "./Block.vue?vue&type=script&lang=js"
export * from "./Block.vue?vue&type=script&lang=js"

import "./Block.vue?vue&type=style&index=0&id=bfc63e4a&lang=less"
import "./Block.vue?vue&type=style&index=1&id=bfc63e4a&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfc63e4a"]])

export default __exports__